import {Accordion, Button, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState, useRef} from "react";
import * as Icon from "react-bootstrap-icons";
import {DiaryData, PostNoteBody} from "../../../utilities/constants";
import childService from "../../../../services/childService";
import Loader from "../loader/loader";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-18-image-lightbox";
import { Image } from "react-grid-gallery";

export interface CustomImage extends Image {
    original: string;
}

function CurrentDayDiary(props: any){

    const [firstFood, setFirstFood] = useState<number | undefined>();
    const [secondFood, setSecondFood] = useState<number | undefined>();
    const [sideFood, setSideFood] = useState<number | undefined>();
    const [merendaFood, setMerendaFood] = useState<number | undefined>();
    const [feces1Quality, setFeces1Quality] = useState<number | undefined>();
    const [feces2Quality, setFeces2Quality] = useState<number | undefined>();
    const [feces3Quality, setFeces3Quality] = useState<number | undefined>();
    const [milkQuantity, setMilkQuantity] = useState<number | undefined>();
    const [nap1Quality, setNap1Quality] = useState<number | undefined>();
    const [nap2Quality, setNap2Quality] = useState<number | undefined>();
    const [notes, setNotes] = useState<string | undefined>();
    const [activities, setActivities] = useState<string | undefined>();
    const [currentNote, setCurrentNote] = useState<PostNoteBody>();
    const [loading, setLoading] = useState(false);

    const [images, setImages] = useState<File[]>([]);
    const [existingImages, setExistingImages] = useState<any[]>([]); // Immagini già salvate nel backend
    const [imageLoading, setImageLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [imageToDelete, setImageToDelete] = useState<{ type: 'new' | 'existing', index: number, id?: string } | null>(null);
    // Tentativi falliti per singola miniatura: 1 = in attesa del retry automatico,
    // 2 = fallito anche il retry, mostriamo un placeholder invece del riquadro vuoto
    const [imageErrors, setImageErrors] = useState<{[imageId: string]: number}>({});
    // true se non siamo riusciti a recuperare le immagini già caricate oggi: in questo caso non possiamo
    // fidarci del conteggio locale (existingImages resterebbe a []) per calcolare quante immagini restano
    const [imagesLoadError, setImagesLoadError] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const totalSelected = images.length + existingImages.length;
    const remaining = Math.max(0, 3 - (images.length + existingImages.length));

    const [index, setIndex] = useState(-1);
    const [galleryImages, setGalleryImages] = useState<CustomImage[]>([]);
    const currentImage = galleryImages[index];
    const nextIndex = (index + 1) % galleryImages.length;
    const nextImage = galleryImages[nextIndex] || currentImage;
    const prevIndex = (index + galleryImages.length - 1) % galleryImages.length;
    const prevImage = galleryImages[prevIndex] || currentImage;

    const changePrimo = (e) => {
        setFirstFood(parseInt(e.target.value));
    }
    const changeSecondo = (e) => {
        setSecondFood(parseInt(e.target.value));
    }
    const changeContorno = (e) => {
        setSideFood(parseInt(e.target.value));
    }
    const changeMerenda = (e) => {
        setMerendaFood(parseInt(e.target.value));
    }
    const changeFeces1 = (e) => {
        setFeces1Quality(parseInt(e.target.value) > -1 ? parseInt(e.target.value) : undefined);
    }
    const changeFeces2 = (e) => {
        setFeces2Quality(parseInt(e.target.value) > -1 ? parseInt(e.target.value) : undefined);
    }
    const changeFeces3 = (e) => {
        setFeces3Quality(parseInt(e.target.value) > -1 ? parseInt(e.target.value) : undefined);
    }
    const changeMilk = (e) => {
        setMilkQuantity(parseInt(e.target.value) > -1 ? parseInt(e.target.value) : undefined);
    }
    const changeNap1 = (e) => {
        setNap1Quality(parseInt(e.target.value) > -1 ? parseInt(e.target.value) : undefined);
    }
    const changeNap2 = (e) => {
        setNap2Quality(parseInt(e.target.value) > -1 ? parseInt(e.target.value) : undefined);
    }
    const changeNotes = (e) => {
        setNotes(e.target.value);
    }
    const changeActivities = (e) => {
        setActivities(e.target.value);
    }

    // Nuove funzioni per le immagini
    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []) as File[];
        const totalImages = images.length + existingImages.length;
        const availableSlots = 3 - totalImages;

        if (files.length > availableSlots) {
            props.onNotification({
                type: 'warning',
                message: `Puoi caricare massimo ${availableSlots} immagini aggiuntive (limite: 3 totali)`
            });
            return;
        }

        const validFiles = files.filter((file: File) => {
            if (!file.type.startsWith('image/')) {
                props.onNotification({
                    type: 'warning',
                    message: `File ${file.name} non è un'immagine valida`
                });
                return false;
            }
            if (file.size > 5 * 1024 * 1024) {
                props.onNotification({
                    type: 'warning',
                    message: `L'immagine ${file.name} supera il limite di 5MB.`
                });
                return false;
            }
        return true;
        });

        setImages(prev => [...prev, ...validFiles]);
        e.target.value = ''; // Reset input
    };

    // Ritenta una volta il caricamento di una miniatura dopo un breve errore (es. backend momentaneamente
    // sotto carico); se fallisce anche il retry mostriamo un placeholder invece del riquadro vuoto
    const handleImageError = (imageId: string) => {
        setImageErrors(prev => {
            const attempts = prev[imageId] || 0;
            if (attempts === 0) {
                setTimeout(() => setImageErrors(p => ({ ...p, [imageId]: 1 })), 2000);
                return prev;
            }
            return { ...prev, [imageId]: 2 };
        });
    };

    // Permette di ritentare manualmente una miniatura dopo che anche il retry automatico è fallito
    const retryImage = (imageId: string) => {
        setImageErrors(prev => ({ ...prev, [imageId]: 0 }));
    };

    const confirmDeleteImage = (type: 'new' | 'existing', index: number, id?: string) => {
        setImageToDelete({ type, index, id });
        setShowDeleteModal(true);
    };

    const handleDeleteImage = async () => {
        if (!imageToDelete) return;

        if (imageToDelete.type === 'new') {
            // Rimuovi immagine non ancora caricata
            setImages(prev => prev.filter((_, i) => i !== imageToDelete.index));
        } else {
            // Rimuovi immagine esistente dal backend
            if (!imageToDelete.id) {
                props.onNotification({
                    type: 'danger',
                    message: 'ID immagine mancante'
                });
                setShowDeleteModal(false);
                setImageToDelete(null);
                return;
            }

            try {
                setImageLoading(true);
                await childService.deleteImage(imageToDelete.id);
                setExistingImages(prev => prev.filter((_, i) => i !== imageToDelete.index));
                props.onNotification({ type: 'success', message: 'Immagine eliminata con successo!' });
            } catch (error: any) {
                props.onNotification({
                    type: 'danger',
                    message: `Errore nell'eliminazione dell'immagine: ${error.response?.data?.message}`
                });
            } finally {
                setImageLoading(false);
            }
        }

        setShowDeleteModal(false);
        setImageToDelete(null);
    };

    const handleUploadImages = async () => {
        if (images.length === 0) {
            props.onNotification({ type: 'warning', message: 'Nessuna immagine da caricare' });
            return;
        }

        try {
            setImageLoading(true);
            const formData = new FormData();
            images.forEach((image, index) => {
                formData.append(`images[${index}]`, image);
            });
            if(currentNote !== undefined && currentNote.id){
                const response = await childService.uploadImages(formData, currentNote.id); // Assumendo che esista questo service
                // Aggiungi le nuove immagini a quelle esistenti
                setExistingImages(response.images);
                setImages([]); // Svuota le immagini temporanee

                props.onNotification({ type: 'success', message: 'Immagini caricate con successo!' });
            } else {
                return;
            }

        } catch (error: any) {
            props.onNotification({
                type: 'danger',
                message: `Errore nel caricamento delle immagini: ${error.response?.data?.message}`
            });
        } finally {
            setImageLoading(false);
        }
    };

    // Funzioni per gestire la lightbox
    const handleImageClick = (imageIndex: number, source: 'new' | 'existing') => {
        let imagesToShow: CustomImage[] = [];

        if (source === 'new') {
            imagesToShow = images.map((image, idx) => ({
                src: URL.createObjectURL(image),
                original: URL.createObjectURL(image),
                caption: `Immagine da caricare ${idx + 1}`,
                width: 100,
                height: 100
            }));
        } else {
            imagesToShow = existingImages.map((image, idx) => ({
                src: image.download_url,
                original: image.download_url,
                caption: `Immagine caricata ${idx + 1}`,
                width: 100,
                height: 100
            }));
        }

        setGalleryImages(imagesToShow);
        setIndex(imageIndex);
    };

    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);

    useEffect(() => {
        if (firstFood != undefined || secondFood != undefined || sideFood != undefined || merendaFood != undefined || feces1Quality != undefined || feces2Quality != undefined || feces3Quality != undefined || nap1Quality != undefined || nap2Quality != undefined){
            //postDiary(firstFood, secondFood, sideFood, fecesQuality); // TODO ad ogni change mandare la call? o mandarla solo quando premo sul submit? attualmente fa una post e non cancella la nota precedente, quindi mantengo 1 sola call quando schiacciano il bottone, altrimenti si riempie il DB di note. più avanti si potrà pensare di de commentare questa riga per permettere di mandare le richieste ad ogni cambio effettivo
        }
    }, [firstFood, secondFood, sideFood, merendaFood, feces1Quality, feces2Quality, feces3Quality, nap1Quality, nap2Quality])

    useEffect(() => {
        // Carica il diario (e le relative immagini) solo quando la scheda viene aperta la prima volta,
        // così le schede di tutti i bambini non fanno tutte richieste insieme al caricamento della pagina
        if (!props.shouldLoad) {
            return;
        }
        const getDiary = async () => {
            try {
                const response = await childService.getDiary({
                    sortBy: "created_at",
                    sort: "DESC"
                }, props.eventKey);
                console.log(response.data);
                // Filtra gli oggetti per oggi
                const todayEntry = filterDiaryEntriesForToday(response.data);
                if (todayEntry) {
                    setCurrentNote({
                        id: todayEntry.id,
                        notes: todayEntry.notes,
                        activities: todayEntry.activities,
                        food_first_course: todayEntry.food_first_course,
                        food_second_course: todayEntry.food_second_course,
                        food_side: todayEntry.food_side,
                        food_merenda: todayEntry.food_merenda,
                        feces_1_quality: todayEntry.feces_1_quality,
                        feces_2_quality: todayEntry.feces_2_quality,
                        feces_3_quality: todayEntry.feces_3_quality,
                        milk: todayEntry.milk,
                        nap_1_quality: todayEntry.nap_1_quality,
                        nap_2_quality: todayEntry.nap_1_quality,
                        been_read: todayEntry.been_read})
                    setFirstFood(todayEntry.food_first_course);
                    setSecondFood(todayEntry.food_second_course);
                    setSideFood(todayEntry.food_side);
                    setMerendaFood(todayEntry.food_merenda);
                    setFeces1Quality(todayEntry.feces_1_quality);
                    setFeces2Quality(todayEntry.feces_2_quality);
                    setFeces3Quality(todayEntry.feces_3_quality);
                    setMilkQuantity(todayEntry.milk);
                    setNap1Quality(todayEntry.nap_1_quality);
                    setNap2Quality(todayEntry.nap_2_quality);
                    setNotes(todayEntry.notes);
                    setActivities(todayEntry.activities);
                    getImages(todayEntry.id);
                } else {
                    console.log("Nessuna voce per oggi.");
                }
            } catch (error) {
                console.error('Errore durante il recupero del diario del bambino:', error);
            }
        };
        getDiary();
    }, [props.shouldLoad]);

    const getImages = async (id: string) => {
        try {
            const response = await childService.getImages(id)
            console.log(response);
            setExistingImages(response)
            setImagesLoadError(false);
        } catch (error) {
            console.error('Errore durante il recupero delle immagini:', error);
            // Non lasciamo existingImages a [], altrimenti sembrerebbe che non ci siano immagini
            // caricate e si potrebbe superare il limite reale lato server senza saperlo
            setImagesLoadError(true);
        }
    };

    // Funzione per filtrare gli oggetti per la data `created_at`
    function filterDiaryEntriesForToday(entries: DiaryData[]): DiaryData | null {
        const today = new Date().toISOString().split('T')[0]; // Ottieni la data di oggi nel formato "YYYY-MM-DD"
        const todayEntries = entries.filter(entry => entry.created_at.startsWith(today));

        // Se ci sono voci per oggi, restituisci solo la prima
        if (todayEntries.length > 0) {
            return todayEntries[0];
        } else {
            return null; // Se non ci sono voci per oggi, restituisci null
        }
    }

    const postOrPutDiary = (firstFood?: number, secondFood?: number, sideFood?: number, merendaFood?: number, feces1Quality?: number, feces2Quality?: number, feces3Quality?: number, milk?: number, nap1Quality?: number, nap2Quality?: number, notes?: string, activities?: string) => {
        if (currentNote?.id) {
            console.log("putting data");
            childService.putDiary({notes: notes, activities: activities, food_first_course: firstFood, food_second_course: secondFood, food_side: sideFood, food_merenda: merendaFood, feces_1_quality: feces1Quality, feces_2_quality: feces2Quality, feces_3_quality: feces3Quality, milk: milkQuantity, nap_1_quality: nap1Quality, nap_2_quality: nap2Quality}, currentNote.id)
                .then((response) => {
                    props.onNotification({ type: 'success', message: 'Note aggiornate con successo!' });
                    console.log(response);
                    setLoading(false);
                })
                .catch((error) => {
                    props.onNotification({ type: 'danger', message: `Si è verificato un errore: ${error.response?.data?.message}` });
                    console.log(error.response?.data?.message)
                    setLoading(false);
                })
        } else {
            console.log("posting data");
            childService.postDiary({notes: notes, activities: activities, food_first_course: firstFood, food_second_course: secondFood, food_side: sideFood, food_merenda: merendaFood, feces_1_quality: feces1Quality, feces_2_quality: feces2Quality, feces_3_quality: feces3Quality, milk: milkQuantity, nap_1_quality: nap1Quality, nap_2_quality: nap2Quality}, props.eventKey)
                .then((response) => {
                    setCurrentNote({id: response.data.id});
                    props.onNotification({ type: 'success', message: 'Note inserite con successo!' });
                    console.log(response);
                    setLoading(false);
                })
                .catch((error) => {
                    props.onNotification({ type: 'danger', message: `Si è verificato un errore: ${error.error.response?.data?.message}` });
                    console.log(error.response?.data?.message)
                    setLoading(false);
                })
        }
        return;

    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        postOrPutDiary(firstFood, secondFood, sideFood, merendaFood, feces1Quality, feces2Quality, feces3Quality, milkQuantity, nap1Quality, nap2Quality, notes, activities);
    }

    require("./currentDayDiary.css");
    return(
        <>
            <Accordion.Item eventKey={props.eventKey}>
                {loading && <Loader />}
                <Accordion.Header>{props.title}</Accordion.Header>
                <Accordion.Body>
                    <Form onSubmit={handleSubmit} className="diaryForm">
                        <h3><b className="tertiary">Pasti:</b></h3>
                        <div className="table-responsive">
                            <table className="table">
                                <tr>
                                    <td><b>Primo:</b></td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "primo"} id={props.eventKey + "primo1"} autoComplete="off" value="0" onChange={changePrimo} checked={firstFood === 0} />
                                        <label className="" htmlFor={props.eventKey + "primo1"}>Niente</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "primo"} id={props.eventKey + "primo2"} autoComplete="off" value="1" onChange={changePrimo} checked={firstFood === 1} />
                                        <label className="" htmlFor={props.eventKey + "primo2"}>Poco</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "primo"} id={props.eventKey + "primo3"} autoComplete="off" value="2" onChange={changePrimo} checked={firstFood === 2} />
                                        <label className="" htmlFor={props.eventKey + "primo3"}>Metà</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "primo"} id={props.eventKey + "primo4"} autoComplete="off" value="3" onChange={changePrimo} checked={firstFood === 3} />
                                        <label className="" htmlFor={props.eventKey + "primo4"}>Tutto</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "primo"} id={props.eventKey + "primo5"} autoComplete="off" value="4" onChange={changePrimo} checked={firstFood === 4} />
                                        <label className="" htmlFor={props.eventKey + "primo5"}>Bis</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Secondo:</b></td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "secondo"} id={props.eventKey + "secondo1"} autoComplete="off" value="0" onChange={changeSecondo} checked={secondFood === 0} />
                                        <label className="" htmlFor={props.eventKey + "secondo1"}>Niente</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "secondo"} id={props.eventKey + "secondo2"} autoComplete="off" value="1" onChange={changeSecondo} checked={secondFood === 1} />
                                        <label className="" htmlFor={props.eventKey + "secondo2"}>Poco</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "secondo"} id={props.eventKey + "secondo3"} autoComplete="off" value="2" onChange={changeSecondo} checked={secondFood === 2} />
                                        <label className="" htmlFor={props.eventKey + "secondo3"}>Metà</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "secondo"} id={props.eventKey + "secondo4"} autoComplete="off" value="3" onChange={changeSecondo} checked={secondFood === 3} />
                                        <label className="" htmlFor={props.eventKey + "secondo4"}>Tutto</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "secondo"} id={props.eventKey + "secondo5"} autoComplete="off" value="4" onChange={changeSecondo} checked={secondFood === 4} />
                                        <label className="" htmlFor={props.eventKey + "secondo5"}>Bis</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Contorno:</b></td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "contorno"} id={props.eventKey + "contorno1"} autoComplete="off" value="0" onChange={changeContorno} checked={sideFood === 0} />
                                        <label className="" htmlFor={props.eventKey + "contorno1"}>Niente</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "contorno"} id={props.eventKey + "contorno2"} autoComplete="off" value="1" onChange={changeContorno} checked={sideFood === 1} />
                                        <label className="" htmlFor={props.eventKey + "contorno2"}>Poco</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "contorno"} id={props.eventKey + "contorno3"} autoComplete="off" value="2" onChange={changeContorno} checked={sideFood === 2} />
                                        <label className="" htmlFor={props.eventKey + "contorno3"}>Metà</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "contorno"} id={props.eventKey + "contorno4"} autoComplete="off" value="3" onChange={changeContorno} checked={sideFood === 3} />
                                        <label className="" htmlFor={props.eventKey + "contorno4"}>Tutto</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "contorno"} id={props.eventKey + "contorno5"} autoComplete="off" value="4" onChange={changeContorno} checked={sideFood === 4} />
                                        <label className="" htmlFor={props.eventKey + "contorno5"}>Bis</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Merenda:</b></td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "merenda"} id={props.eventKey + "merenda1"} autoComplete="off" value="0" onChange={changeMerenda} checked={merendaFood === 0} />
                                        <label className="" htmlFor={props.eventKey + "merenda1"}>Niente</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "merenda"} id={props.eventKey + "merenda2"} autoComplete="off" value="1" onChange={changeMerenda} checked={merendaFood === 1} />
                                        <label className="" htmlFor={props.eventKey + "merenda2"}>Poco</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "merenda"} id={props.eventKey + "merenda3"} autoComplete="off" value="2" onChange={changeMerenda} checked={merendaFood === 2} />
                                        <label className="" htmlFor={props.eventKey + "merenda3"}>Metà</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "merenda"} id={props.eventKey + "merenda4"} autoComplete="off" value="3" onChange={changeMerenda} checked={merendaFood === 3} />
                                        <label className="" htmlFor={props.eventKey + "merenda4"}>Tutto</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "merenda"} id={props.eventKey + "merenda5"} autoComplete="off" value="4" onChange={changeMerenda} checked={merendaFood === 4} />
                                        <label className="" htmlFor={props.eventKey + "merenda5"}>Bis</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Latte:</b></td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "latte"} id={props.eventKey + "latte1"} autoComplete="off" value="0" onChange={changeMilk} checked={milkQuantity === 0} />
                                        <label className="" htmlFor={props.eventKey + "latte1"}>Niente</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "latte"} id={props.eventKey + "latte2"} autoComplete="off" value="1" onChange={changeMilk} checked={milkQuantity === 1} />
                                        <label className="" htmlFor={props.eventKey + "latte2"}>Poco</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "latte"} id={props.eventKey + "latte3"} autoComplete="off" value="2" onChange={changeMilk} checked={milkQuantity === 2} />
                                        <label className="" htmlFor={props.eventKey + "latte3"}>Metà</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "latte"} id={props.eventKey + "latte4"} autoComplete="off" value="3" onChange={changeMilk} checked={milkQuantity === 3} />
                                        <label className="" htmlFor={props.eventKey + "latte4"}>Tutto</label>
                                    </td>
                                    <td>
                                        <input type="radio" className="" name={props.eventKey + "latte"} id={props.eventKey + "latte5"} autoComplete="off" value="4" onChange={changeMilk} checked={milkQuantity === 4} />
                                        <label className="" htmlFor={props.eventKey + "latte5"}>Bis</label>
                                    </td>
                                </tr>

                            </table>
                        </div>
                        <div className="d-flex mb-3">
                            <h3 className="d-inline-block"><b className="tertiary">Cacca:</b></h3>
                            <Form.Select className="form-select d-inline-block ms-3" onChange={changeFeces1} value={feces1Quality?.toString()} >
                                <option value="-1">-- seleziona --</option>
                                <option value="0">Liquida</option>
                                <option value="1">Molle</option>
                                <option value="2">Bella</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex mb-3">
                            <h3 className="d-inline-block"><b className="tertiary">Cacca:</b></h3>
                            <Form.Select className="form-select d-inline-block ms-3" onChange={changeFeces2} value={feces2Quality?.toString()} >
                                <option value="-1">-- seleziona --</option>
                                <option value="0">Liquida</option>
                                <option value="1">Molle</option>
                                <option value="2">Bella</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex mb-3">
                            <h3 className="d-inline-block"><b className="tertiary">Cacca:</b></h3>
                            <Form.Select className="form-select d-inline-block ms-3" onChange={changeFeces3} value={feces3Quality?.toString()} >
                                <option value="-1">-- seleziona --</option>
                                <option value="0">Liquida</option>
                                <option value="1">Molle</option>
                                <option value="2">Bella</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex mb-3">
                            <h3 className="d-inline-block"><b className="tertiary">Nanna mattino:</b></h3>
                            <Form.Select className="form-select d-inline-block ms-3" onChange={changeNap1} value={nap1Quality?.toString()} >
                                <option value="-1">-- seleziona --</option>
                                <option value="0">Mezz'ora</option>
                                <option value="1">1 ora</option>
                                <option value="2">1 ora e mezza</option>
                                <option value="3">2 ore</option>
                                <option value="4">2 ore e mezza</option>
                                <option value="5">3 ore</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex mb-3">
                            <h3 className="d-inline-block"><b className="tertiary">Nanna pomeriggio:</b></h3>
                            <Form.Select className="form-select d-inline-block ms-3" onChange={changeNap2} value={nap2Quality?.toString()} >
                                <option value="-1">-- seleziona --</option>
                                <option value="0">Mezz'ora</option>
                                <option value="1">1 ora</option>
                                <option value="2">1 ora e mezza</option>
                                <option value="3">2 ore</option>
                                <option value="4">2 ore e mezza</option>
                                <option value="5">3 ore</option>
                            </Form.Select>
                        </div>
                        <Form.Group className="mb-3" controlId={props.eventKey + "ControlTextarea"}>
                            <h3><b className="tertiary">Attività</b></h3>
                            <Form.Control as="textarea" rows={3} placeholder="Inserisci attività" onChange={changeActivities} value={activities} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId={props.eventKey + "ControlTextarea"}>
                            <h3><b className="tertiary">Note</b></h3>
                            <Form.Control as="textarea" rows={3} placeholder="Inserisci note" onChange={changeNotes} value={notes} />
                        </Form.Group>

                        <div className="mb-4">
                            <h3><b className="tertiary">Immagini</b></h3>

                            {imagesLoadError ? (
                                // Non possiamo fidarci del conteggio locale (existingImages è rimasto vuoto)
                                // quindi nascondiamo l'upload finché non si riesce a verificare quante immagini ci sono già
                                <div className="mb-3 p-3 border border-danger rounded text-center">
                                    <small className="text-danger d-block mb-2">
                                        Impossibile verificare le immagini già caricate oggi per questo bambino.
                                    </small>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => currentNote?.id && getImages(currentNote.id)}
                                    >
                                        Riprova
                                    </button>
                                </div>
                            ) : (
                            <>
                            {/* Input nascosto */}
                            <input
                                ref={fileInputRef}
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={handleImageUpload}
                                style={{ display: 'none' }}
                                disabled={images.length + existingImages.length >= 3}
                            />

                            {/* Drop zone cliccabile */}
                            <div
                                className="mb-3 p-4 border border-warning rounded text-center"
                                style={{
                                    backgroundColor: '#fff3cd',
                                    cursor: images.length + existingImages.length >= 3 ? 'not-allowed' : 'pointer',
                                    minHeight: '120px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    opacity: images.length + existingImages.length >= 3 ? 0.6 : 1
                                }}
                                onClick={() => {
                                    if (images.length + existingImages.length < 3) {
                                        fileInputRef.current?.click();
                                    }
                                }}
                            >
                                <div className="mb-2">
                                    {images.length + existingImages.length >= 3 ? (
                                        <>
                                            <div style={{ fontSize: '2rem' }}>🚫</div>
                                            <h5 className="mb-1" style={{ color: '#856404' }}>
                                                <b>Limite raggiunto</b>
                                            </h5>
                                            <small className="text-muted d-block">
                                                Hai raggiunto il limite massimo di 3 immagini giornaliere.
                                            </small>
                                            {images.length > 0 &&
                                                <small className="text-muted">
                                                    Premi <strong>“Invia immagini”</strong> per condividerle con i genitori.
                                                </small>
                                            }
                                        </>
                                    ) : images.length > 0 ? (
                                        <>
                                            <h5 className="mb-1" style={{ color: '#856404' }}>
                                                <b>⏳ {images.length} immagin{images.length > 1 ? 'i' : 'e'} da inviare</b>
                                            </h5>

                                            <small className="text-muted d-block">
                                                Rimanenti oggi: {remaining}.
                                            </small>

                                            <small className="text-muted">
                                                Quando hai finito, premi <strong>“Invia immagini”</strong> per condividerle con i genitori (max 5MB ognuna).
                                            </small>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ fontSize: '2rem' }}>📷</div>
                                            <h5 className="mb-1" style={{ color: '#856404' }}>
                                                <b>Aggiungi immagini</b>
                                            </h5>
                                            <small className="text-muted d-block">
                                                Puoi inviare fino a <strong>3 immagini al giorno</strong> (rimanenti: {remaining}).
                                            </small>
                                            <small className="text-muted">
                                                Quando hai finito, premi <strong>“Invia immagini”</strong> per condividerle con i genitori (max 5MB ognuna).
                                            </small>
                                        </>
                                    )}
                                </div>

                                {/* Anteprima immagini da caricare */}
                                {images.length > 0 && (
                                    <div className="mt-3">
                                        <div className="d-flex flex-wrap justify-content-center gap-2">
                                            {images.map((image, index) => (
                                                <div
                                                    key={index}
                                                    className="position-relative"
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleImageClick(index, 'new');
                                                    }}
                                                >
                                                    <img
                                                        src={URL.createObjectURL(image)}
                                                        alt={`Preview ${index}`}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            opacity: '0.8',
                                                            filter: 'grayscale(20%)'
                                                        }}
                                                        className="rounded border border-warning"
                                                    />
                                                    {/* Overlay "da caricare" */}
                                                    <div
                                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center"
                                                        style={{
                                                            background: 'linear-gradient(to top, rgba(255,193,7,0.8) 0%, transparent 50%)',
                                                            borderRadius: '0.375rem'
                                                        }}
                                                    >
                                                        <small style={{ color: '#000', fontWeight: 'bold', fontSize: '9px' }}>DA INVIARE</small>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="position-absolute"
                                                        style={{
                                                            top: '0px',
                                                            right: '0px',
                                                            width: '20px',
                                                            height: '20px',
                                                            borderRadius: '50%',
                                                            padding: '0',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '10px',
                                                            lineHeight: '1',
                                                            zIndex: 10,
                                                            backgroundColor: '#dc3545', // rosso Bootstrap danger
                                                            color: '#fff',              // testo bianco
                                                            border: 'none'             // rimuovi bordo se presente
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            confirmDeleteImage('new', index);
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Immagini già caricate */}
                            {existingImages.length > 0 && (
                                <div className="mb-3">
                                    <div className="d-flex align-items-center mb-2">
                                        <h5 className="mb-0 me-2"><b style={{ color: '#198754' }}>✓ {existingImages.length} Immagin{existingImages.length > 1 ? 'i' : 'e'} inviat{existingImages.length > 1 ? 'e' : 'a'}</b></h5>
                                    </div>
                                    <div className="d-flex flex-wrap gap-2">
                                        {existingImages.map((image, index) => (
                                            <div
                                                key={image.id || index}
                                                className="position-relative"
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleImageClick(index, 'existing');
                                                }}
                                            >
                                                {imageErrors[image.id] === 2 ? (
                                                    <div
                                                        className="d-flex flex-column align-items-center justify-content-center bg-light rounded border border-success text-muted text-center"
                                                        style={{ width: '100%', height: '100%' }}
                                                        title="Immagine non disponibile, clicca per vederla in grande o riprova"
                                                    >
                                                        <small>Non disponibile</small>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary mt-1"
                                                            style={{ fontSize: '10px', padding: '1px 6px' }}
                                                            onClick={(e) => { e.stopPropagation(); retryImage(image.id); }}
                                                        >
                                                            Riprova
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <img
                                                        src={imageErrors[image.id] === 1 ? `${image.download_url}?retry=1` : image.download_url}
                                                        alt={`Caricata ${index}`}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            opacity: '0.8',
                                                            filter: 'grayscale(20%)'
                                                        }}
                                                        className="rounded border border-success"
                                                        onError={() => handleImageError(image.id)}
                                                    />
                                                )}
                                                {/* Overlay caricata: solo decorativo, non deve intercettare i click
                                                    (altrimenti coprirebbe il pulsante "Riprova" del placeholder sottostante) */}
                                                <div
                                                    className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center"
                                                    style={{
                                                        background: 'linear-gradient(to top, rgba(255,193,7,0.8) 0%, transparent 50%)',
                                                        borderRadius: '0.375rem',
                                                        pointerEvents: 'none'
                                                    }}
                                                >
                                                    <small style={{ color: '#000', fontWeight: 'bold', fontSize: '9px' }}>INVIATA</small>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="position-absolute"
                                                    style={{
                                                    top: '0px',
                                                    right: '0px',
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '50%',
                                                    padding: '0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '10px',
                                                    lineHeight: '1',
                                                    zIndex: 10,
                                                    backgroundColor: '#dc3545', // rosso Bootstrap danger
                                                    color: '#fff',              // testo bianco
                                                    border: 'none'             // rimuovi bordo se presente
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    confirmDeleteImage('existing', index, image.id);
                                                }}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Pulsante per caricare le immagini */}
                            {images.length > 0 && (
                                <div className="d-flex align-items-center justify-content-between p-3 border rounded mb-3 my-bg-body-primary">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <div className="fw-bold mb-1">
                                                Pronto per l'invio
                                            </div>
                                            <small className="text-muted">
                                                {images.length} immagin{images.length > 1 ? 'i' : 'e'} selezionat{images.length > 1 ? 'e' : 'a'}
                                            </small>
                                        </div>
                                    </div>
                                    {currentNote !== undefined && currentNote.id ? (
                                        <Button
                                            variant="primary"
                                            onClick={handleUploadImages}
                                            disabled={imageLoading}
                                            className="fw-bold"
                                            style={{ minWidth: '140px' }}
                                        >
                                            {imageLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                    Salvataggio...
                                                </>
                                            ) : (
                                                'Invia immagini'
                                            )}
                                        </Button>
                                        ) : (
                                        <div className="text-center" style={{ minWidth: '140px' }}>
                                            <div className="text-center mb-2">
                                                <span className="fw-medium text-muted">Non disponibile</span>
                                            </div>
                                            <small className="text-muted d-block" style={{ fontSize: '0.75rem', lineHeight: '1.3' }}>
                                                Per caricare le immagini devi prima salvare le note del giorno
                                            </small>
                                        </div>
                                        )
                                    }
                                </div>
                            )}
                            </>
                            )}
                            {/* Lightbox per visualizzare le immagini */}
                            {index >= 0 && !!currentImage && (
                                /* @ts-ignore */
                                // Con una sola immagine, next/prev coinciderebbero con quella corrente:
                                // li omettiamo per evitare richieste duplicate della stessa immagine
                                <Lightbox
                                    mainSrc={currentImage.original}
                                    imageTitle={currentImage.caption}
                                    mainSrcThumbnail={currentImage.src}
                                    nextSrc={galleryImages.length > 1 ? nextImage?.original : undefined}
                                    nextSrcThumbnail={galleryImages.length > 1 ? nextImage?.src : undefined}
                                    prevSrc={galleryImages.length > 1 ? prevImage?.original : undefined}
                                    prevSrcThumbnail={galleryImages.length > 1 ? prevImage?.src : undefined}
                                    onCloseRequest={handleClose}
                                    onMovePrevRequest={handleMovePrev}
                                    onMoveNextRequest={handleMoveNext}
                                />
                            )}
                        </div>

                        <Button variant="success" type="submit">
                            Aggiorna note
                        </Button>
                    </Form>
                </Accordion.Body>
            </Accordion.Item>

            {/* Modal di conferma eliminazione */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Conferma eliminazione</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Sei sicuro di voler eliminare questa immagine?
                    {imageToDelete?.type === 'existing' && (
                        <div className="mt-2">
                            <small className="text-warning">
                                <strong>Attenzione:</strong> L'immagine verrà eliminata definitivamente dal server.
                            </small>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Annulla
                    </Button>
                    <Button variant="danger" onClick={handleDeleteImage}>
                        Elimina
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CurrentDayDiary;